export default "__VITE_ASSET__CtOzlniF__"